import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right-arrow",
  "use": "icon-right-arrow-usage",
  "viewBox": "0 0 26 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 22\" id=\"icon-right-arrow\"><path fill=\"#fff\" d=\"M15.01 0L26 10.983 15.013 21.966l-1.294-1.29 8.777-8.778H.373v-1.83h22.123l-8.78-8.781z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol